<template>
  <div class="box is-centered wrapper-data-receiver">
    <h1 class="title has-text-primary title-data-receiver">
      Información
    </h1>

    <div class="columns is-multiline">
      <div
        v-if="!isTradeTransfer"
        class="column"
        :class="{ 'is-6': !inline, 'is-4': inline }"
      >
        <BField
          label="RFC"
          label-for="customerRFC"
        >
          <BInput
            id="customerRFC"
            name="rfc"
            :disabled="isLoading || disabled"
            :value="$store.state.invoice.receiverRfc"
            :pattern="pattern"
            required
            maxlength="13"
            @input="onChange('receiverRfc', $event)"
            @change="onChange('receiverRfc', $event)"
          />
        </BField>
      </div>

      <div
        class="column"
        :class="{ 'is-6': !inline, 'is-4': inline }"
      >
        <BField
          label="Razón social"
          label-for="customerCompanyName"
        >
          <BInput
            id="customerCompanyName"
            name="companyName"
            :disabled="isLoading || disabled"
            :value="$store.state.customers.companyName"
            required
            @input="onChange('receiverName', $event)"
            @change="onChange('receiverName', $event)"
          />
        </BField>
      </div>

      <div
        class="column"
        :class="{ 'is-6': !inline, 'is-4': inline }"
      >
        <BField
          label="Email"
          label-for="customerEmail"
        >
          <BInput
            id="customerEmail"
            name="email"
            type="email"
            :disabled="isLoading || disabled"
            :value="$store.state.customers.email"
            required
            @input="onChange('operation.email', $event)"
            @change="onChange('operation.email', $event)"
          />
        </BField>
      </div>

      <div
        class="column"
        :class="{ 'is-6': !inline, 'is-4': inline }"
      >
        <BField
          label="Nombre"
          label-for="customerName"
        >
          <BInput
            id="customerName"
            name="name"
            :disabled="isLoading || disabled"
            :value="$store.state.customers.name"
            required
            @input="onChange('operation.name', $event)"
            @change="onChange('operation.name', $event)"
          />
        </BField>
      </div>

      <div
        class="column"
        :class="{ 'is-6': !inline, 'is-4': inline }"
      >
        <BField
          label="Código postal"
          label-for="privateZipCode"
        >
          <BInput
            id="privateZipCode"
            :value="$store.state.customers.zipCode"
            placeholder="00000"
            icon="account-card-details"
            :pattern="zipCodePattern"
            :disabled="disabled"
            :loading="isLoading"
            required
            @input="onInput('zipCode', $event)"
          />
        </BField>
      </div>

      <div
        class="column"
        :class="{ 'is-6': !inline, 'is-4': inline }"
      >
        <AppSelectSearch
          id="privateTaxRegime"
          name="privateTaxRegime"
          label="Régimen fiscal"
          icon="domain"
          :options="taxRegimeCatalog"
          :value="taxRegimeSelected()"
          required
          @input="onInput('taxRegime', $event.target.value)"
          @change="onInput('taxRegime', $event.target.value)"
        />
      </div>

      <div
        v-if="!isTradeTransfer"
        class="column is-12 is-centered"
      >
        <div class="field">
          <label
            class="label"
          >
            ¿Eres extranjero?
          </label>
          <div class="control is-flex is-centered">
            <div class="field has-addons">
              <p class="control">
                <a
                  class="button"
                  :class="{ 'is-success': isForeign, 'is-loading': isLoading }"
                  :disabled="disabled"
                  @click="onChangeForeign(true)"
                >
                  <span>Sí</span>
                </a>
              </p>
              <p class="control">
                <a
                  class="button"
                  :class="{ 'is-success': !isForeign, 'is-loading': isLoading }"
                  :disabled="disabled"
                  @click="onChangeForeign(false)"
                >
                  <span>No</span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <template v-if="isForeign">
        <div
          class="column"
          :class="{ 'is-12': !inline, 'is-4': inline }"
        >
          <AppSelectSearch
            id="receiverFiscalResidence"
            name="receiverFiscalResidence"
            label="Residencia fiscal"
            placeholder="Residencia Fiscal"
            :value="countrySelected"
            :options="countryCatalog"
            :is-loading="isLoading"
            :required="true"
            @input="onChangeSelection"
            @change="onChangeSelection"
          />
        </div>

        <div
          class="column"
          :class="{ 'is-12': !inline, 'is-4': inline }"
        >
          <AppInputField
            id="numRegIdTrib"
            name="receiverNumRegIdTrib"
            label="Número de registro identificación tributaria "
            placeholder="Número de registro identificación tributaria "
            :value="receiverNumRegIdTrib"
            :disabled="disabled"
            :is-loading="isLoading"
            @input="onChange('receiverNumRegIdTrib', $event.target.value)"
            @change="onChange('receiverNumRegIdTrib', $event.target.value)"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { cfdiUse, country } from '@machete/common-catalogs';
import helpers from '../../../../lib/helpers';

const arrayToOptions = array => array.map(
  ({ key, value }) => ({
    value: key,
    label: `${key} - ${value}`,
  }),
);

export default {
  name: 'AutoInvoiceReceiver',
  components: {
    AppInputField: () => import(/* webpackChunkName: "app-input-field" */ '@/components/AppInputField.vue'),
    AppSelectSearch: () => import(/* webpackChunkName: "app-select-search" */ '@/components/AppSelectSearch.vue'),
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isTradeTransfer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isForeign: false,
      pattern: '^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$',
      cfdiUseCatalog: arrayToOptions(cfdiUse),
      countryCatalog: arrayToOptions(country),
      zipCodePattern: '^[0-9]{5}(?:-[0-9]{4})?$',
    };
  },
  computed: {
    ...mapState({
      receiverOptionsRfcList: state => state.invoice.receiverOptionsRfcList,
      receiverRfc: state => state.invoice.receiverRfc,
      receiverName: state => state.invoice.receiverName,
      receiverCfdiUsage: state => state.invoice.receiverCfdiUsage,
      receiverFiscalResidence: state => state.invoice.receiverFiscalResidence,
      receiverNumRegIdTrib: state => state.invoice.receiverNumRegIdTrib,
      privateTaxRegime: ({ customers }) => customers.taxRegime,
      taxRegimeCatalog: ({ ui, invoice }) => {
        const { taxRegime } = ui.catalogSat;
        const { receiverRfc } = invoice;

        return helpers.arrayToOptionsFilterByRFC(taxRegime, receiverRfc);
      },
    }),
    cfdiUseSelected() {
      return this.cfdiUseCatalog.find(u => u.value === this.receiverCfdiUsage);
    },
    countrySelected() {
      return this.countryCatalog.find(c => c.value === this.receiverFiscalResidence);
    },
  },
  watch: {
    receiverFiscalResidence(value) {
      this.isForeign = (!!value);
    },
  },
  mounted() {
    this.searchByRfc('receiverRfc', this.receiverRfc);
  },
  methods: {
    ...mapMutations({
      setReceiverValue: 'invoice/setValue',
    }),
    onChange(accessor, value) {
      this.setReceiverValue({ accessor, value });
    },
    onChangeSelection(event) {
      const { name: accessor, value } = event.target;

      this.setReceiverValue({ accessor, value });
    },
    taxRegimeSelected() {
      const itemSelected = this.taxRegimeCatalog.find(
        regime => regime.value === this.privateTaxRegime,
      );

      if (!itemSelected) {
        this.onInput('taxRegime', '');
      }

      return itemSelected;
    },
    onInput(name, event) {
      this.$store.commit('customers/setValue', { accessor: name, value: event });
    },
    async searchByRfc(accessor, value) {
      if (value.length >= 12 && (value !== 'XAXX010101000' && value !== 'XEXX010101000')) {
        this.loading = true;

        const customer = await this.$store.dispatch('customers/getById', this.$store.state.invoice.operation.customer);
        this.setStateValues(customer);

        this.loading = false;
      }

      this.setReceiverValue({ accessor, value });
    },
    onChangeForeign(value) {
      if (this.disabled) return;
      this.isForeign = value;
    },
    setStateValues(customer) {
      const {
        name = '',
        email = '',
        rfc = '',
        companyName = '',
        id = '',
      } = customer;

      this.$store.commit('customers/setValues', {
        name,
        email,
        rfc,
        companyName,
        id,
      });

      this.$store.commit('users/setValues', {
        name,
        email,
        rfc,
        companyName,
      });

      this.$store.commit('invoice/setValues', {
        receiverName: companyName,
        receiverRfc: rfc,
        'operation.email': email,
        'operation.name': name,
      });
    },
  },
};
</script>

<style scoped>
.box {
  flex-direction: column;
}

.columns {
  width: 100%;
}

.title {
  flex-direction: row;
}
</style>
